import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import '../styles.css';

const ResetPassword = () => {
  const [contactNumber, setContactNumber] = useState('');
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (location.state) {
      setContactNumber(location.state.contactNumber || '');
    }
  }, [location.state]);

  const handleInputChange = (e, setter) => {
    setter(e.target.value);
    if (error) setError(null);
    if (success) setSuccess(null);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);
    setSuccess(null); 

    try {
      const data = { contact_number: contactNumber, otp, new_password: newPassword };
      console.log('Sending data:', data);
      
      const response = await axios.post('https://attend.teamhalt.com/attendence/api/v1/reset-password/', data, {
        headers: { 'Content-Type': 'application/json' }
      });

      console.log('Response:', response);
      if (response.status === 200 && response.data.message) {
        setSuccess(response.data.message);
        setTimeout(() => {
          navigate('/');
        }, 2000);
      } else {
        setError('Failed to reset password. Please try again.');
      }
    } catch (error) {
      console.error('Error resetting password:', error);

      if (error.response) {
        console.log('Error response data:', error.response.data);
        setError(error.response.data.error || 'Error resetting password. Please try again.');
      } else if (error.request) {
        setError('No response from the server. Please try again.');
      } else {
        setError('An unexpected error occurred. Please try again.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-wrapper">
      <div className="auth-left-section">
        <div className="auth-header">
          <div className="auth-brand-logo">
            {/* <span className="logo-icon">⏱</span> */}
            <img src="/Teamhalt.png" alt="TeamHalt" className="logo-icon" />
            <span className="logo-text">TeamHalt</span>
          </div>
        </div>
        
        <div className="auth-brand-content">
          <h1>Set New Password</h1>
          <p>Create a new password for your account. Make sure to remember it this time!</p>
          <div className="auth-features">
            <div className="feature-item">
              <span className="feature-icon">✓</span>
              <span>Strong Password Recommendation</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">✓</span>
              <span>Minimum 8 Characters</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">✓</span>
              <span>Mix of Letters & Numbers</span>
            </div>
          </div>
        </div>
        
        <div className="auth-footer">
          <Link to="/privacy-policy" className="privacy-link">Privacy Policy</Link>
          <p className="copyright">© 2026 TeamHalt. All rights reserved.</p>
        </div>
      </div>
      
      <div className="auth-right-section">
        <div className="auth-card">
          <div className="auth-header-form">
            <div className="form-icon">🔑</div>
            <h2>Reset Password</h2>
            <p>Enter the OTP and create a new password</p>
          </div>
          
          <form onSubmit={handleResetPassword} className="auth-form-container">
            <div className="form-group">
              <label htmlFor="contactNumber">Contact Number</label>
              <div className="input-wrapper">
                {/* <span className="input-icon">📱</span> */}
                <input
                  type="tel"
                  id="contactNumber"
                  placeholder="Enter your contact number"
                  value={contactNumber}
                  disabled
                />
              </div>
            </div>
            
            <div className="form-group">
              <label htmlFor="otp">Enter OTP</label>
              <div className="input-wrapper">
                {/* <span className="input-icon">🔢</span> */}
                <input
                  type="number"
                  id="otp"
                  placeholder="Enter 6-digit OTP"
                  value={otp}
                  onChange={(e) => handleInputChange(e, setOtp)}
                  required
                  autoComplete="one-time-code"
                />
              </div>
            </div>
            
            <div className="form-group">
              <label htmlFor="newPassword">New Password</label>
              <div className="input-wrapper">
                {/* <span className="input-icon">🔒</span> */}
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="newPassword"
                  placeholder="Enter new password"
                  value={newPassword}
                  onChange={(e) => handleInputChange(e, setNewPassword)}
                  required
                  autoComplete="new-password"
                />
                <button 
                  type="button" 
                  className="password-toggle"
                  onClick={togglePasswordVisibility}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? '👁' : '👁‍🗨'}
                </button>
              </div>
            </div>
            
            {error && (
              <div className="auth-error">
                <span className="error-icon">⚠</span>
                <span>{error}</span>
              </div>
            )}
            
            {success && (
              <div className="auth-success">
                <span className="success-icon">✓</span>
                <span>{success}</span>
              </div>
            )}
            
            <button 
              type="submit" 
              className="auth-button"
              disabled={isLoading}
            >
              {isLoading ? (
                <span className="loading-spinner"></span>
              ) : (
                'Reset Password'
              )}
            </button>
          </form>
          
          <div className="auth-footer-form">
            <Link to="/" className="back-login-link">
              <span>←</span> Back to Login
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
